import React from "react";

export const ToursContext = React.createContext(undefined)

export const useToursContext = () => {
    const context = React.useContext(ToursContext);
    if (context === undefined) throw new Error('useToursContext must be used with a TOursContext')
    return context;
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/context.js